import { render, staticRenderFns } from "./pushMessage.vue?vue&type=template&id=51b0b350&scoped=true&"
import script from "./pushMessage.vue?vue&type=script&lang=js&"
export * from "./pushMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b0b350",
  null
  
)

export default component.exports